export default __webpack_public_path__ + "a08e3e311ded4f5fd9defa3750bfbab9.svg";